// extracted by mini-css-extract-plugin
module.exports = {"container":"student-cabinet-bg_container__11SnT","bg":"student-cabinet-bg_bg__3KDRb","bgDefault":"student-cabinet-bg_bgDefault__TvNrf"};